import { COLOR_LIST } from "src/constants/stats";
import { topPayorsMOSECRProps } from "src/pages/manufacturer/types";


export const wrapperFunctionPieChart = (
  pieChartData: topPayorsMOSECRProps[]
) => {
  return [
    {
      name: "Value",
      type: "pie",
      data:pieChartData && pieChartData.map((item,key) => ({
        name: `${(item.name || "")
          .toUpperCase()
          .replace(/(^\w|[-\s]\w)/g, (match) => match.toUpperCase())}`,
        title: `${(item.name || "")
          .toUpperCase()
          .replace(/(^\w|[-\s]\w)/g, (match) => match.toUpperCase())}`,
        y: item.value,
        color: COLOR_LIST[key]
      })),
    },
  ];
};
